import { useEffect, useState } from 'react';
import { Moon, Sun } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';
import { resolveInitialTheme, toggleTheme, type ThemeMode } from '@/lib/theme';

export const ThemeToggle = () => {
  const { t } = useTranslation();
  const [mode, setMode] = useState<ThemeMode>('dark');

  useEffect(() => {
    setMode(resolveInitialTheme());
  }, []);

  const handleClick = () => {
    setMode((prev) => toggleTheme(prev));
  };

  const label = t('efs.common.topnav.theme');
  const isDark = mode === 'dark';

  return (
    <Button variant="ghost" size="icon" onClick={handleClick} aria-label={label} title={label}>
      {isDark ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
    </Button>
  );
};
